import LogoNespresso from "../../../../images/content/introduction/associate-members/logo-nespresso.jpg";
import LogoWik from "../../../../images/content/introduction/associate-members/logo-wik.jpg";
import LogoLoreal from "../../../../images/content/introduction/associate-members/logo-loreal.jpg";
import LogoMi from "../../../../images/content/introduction/associate-members/logo-mi.jpg";

export const associateMembers = [
	{
		id: "applia-member-nespresso",
		url: "https://www.nespresso.com/",
		imageUrl: LogoNespresso,
		imageAlt: "Nespresso logo",
	},
	{
		id: "applia-member-wik",
		url: "https://www.wik-group.com/",
		imageUrl: LogoWik,
		imageAlt: "WIK logo",
	},
	{
		id: "applia-member-loreal",
		url: "https://www.loreal.com/",
		imageUrl: LogoLoreal,
		imageAlt: "L'Oréal logo",
	},
	{
		id: "applia-member-mi",
		url: "https://www.mi.com/",
		imageUrl: LogoMi,
		imageAlt: "Mi logo",
	},
];
